<template>

  <SideBarAsideFix/>

  <div class="content ht-100v pd-0">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->


    <div class="content-body">
      <div class="container pd-x-0">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Harvest DataCenter</li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1">Welcome to Dashboard</h4>
          </div>
          <div class="d-none d-md-block">
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i>
              Email
            </button>
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer"
                                                                                 class="wd-10 mg-r-5"></i> Print
            </button>
            <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="file"
                                                                                   class="wd-10 mg-r-5"></i> Generate
              Report
            </button>
          </div>
        </div>


        <div class="contact-grid">

          <!-- Card 1: Carol Thomas -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder">CT</div>
                <div>
                  <p class="card-name">Carol Thomas</p>
                  <p class="card-role">UI /UX Designer</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> caroltho3@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 124547845</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> China</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar">CT</div>
            </div>
          </div>

          <!-- Card 2: Dawn Mercha -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);">
                  DM
                </div>
                <div>
                  <p class="card-name">Dawn Mercha</p>
                  <p class="card-role">Technician</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> dawnmercha@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 478845447</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Martin Lewis</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);">DM</div>
            </div>
          </div>

          <!-- Card 3: Rachel Hampton -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #1c6ef3 0%, #0d4fba 100%);">
                  RH
                </div>
                <div>
                  <p class="card-name">Rachel Hampton</p>
                  <p class="card-role">Software Developer</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> rachel@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 215544845</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Indonesia</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #ec4899 0%, #be185d 100%);">RH</div>
            </div>
          </div>

          <!-- Card 4: Jonelle Curtiss -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #6b7280 0%, #374151 100%);">
                  JC
                </div>
                <div>
                  <p class="card-name">Jonelle Curtiss</p>
                  <p class="card-role">Supervisor</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> jonelle@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 121145471</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Cuba</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);">JC</div>
            </div>
          </div>

          <!-- Card 5: Jonathan Smith -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #374151 0%, #1f2937 100%);">
                  JS
                </div>
                <div>
                  <p class="card-name">Jonathan Smith</p>
                  <p class="card-role">Team Lead Dev</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> jonathan@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 321454789</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Isreal</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);">JS</div>
            </div>
          </div>

          <!-- Card 6: Brook Carter -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #1f2937 0%, #111827 100%);">
                  BC
                </div>
                <div>
                  <p class="card-name">Brook Carter</p>
                  <p class="card-role">Team Lead Dev</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> brook@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 278907145</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Colombia</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);">BC</div>
            </div>
          </div>

          <!-- Card 7: Eric Adams -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);">
                  EA
                </div>
                <div>
                  <p class="card-name">Eric Adams</p>
                  <p class="card-role">HR Manager</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> ericadams@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 19023-78104</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> France</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);">EA</div>
            </div>
          </div>

          <!-- Card 8: Richard Cooper -->
          <div class="contact-card">
            <div class="card-header-row">
              <div class="card-identity">
                <div class="avatar-placeholder" style="background: linear-gradient(135deg, #991b1b 0%, #7f1d1d 100%);">
                  RC
                </div>
                <div>
                  <p class="card-name">Richard Cooper</p>
                  <p class="card-role">Devops Engineer</p>
                </div>
              </div>
              <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
            </div>
            <div class="card-info">
              <div class="info-row"><i class="far fa-envelope"></i> richard@example.com</div>
              <div class="info-row"><i class="fas fa-phone"></i> +1 18902-63904</div>
              <div class="info-row"><i class="fas fa-map-marker-alt"></i> Belgium</div>
            </div>
            <div class="card-tags">
              <span class="tag tag-collab">Collab</span>
              <span class="tag tag-rated">Rated</span>
            </div>
            <div class="card-footer-row">
              <div class="footer-actions">
                <a href="#"><i class="far fa-envelope"></i></a>
                <a href="#"><i class="fas fa-phone"></i></a>
                <a href="#"><i class="far fa-comment"></i></a>
                <a href="#"><i class="fab fa-slack"></i></a>
              </div>
              <div class="footer-avatar" style="background: linear-gradient(135deg, #d97706 0%, #b45309 100%);">RC</div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import visualizationMixin from "@/mixins/visualization-script";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";

export default {
  name: "ContactDashboardCard",
  components: {SideBarAsideFix},
  mixins: [visualizationMixin, footerScriptMixin, serviceMixin],

  created() {
    this.footerScript();
    this.asideBarScript();
  },
}
</script>


<style scoped>
@import '../../assets/css/dashforge.dashboard.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';


.contact-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

@media (max-width: 1200px) {
  .contact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}

.contact-card {
  background: #fff;
  border-radius: 8px;
  padding: 18px 18px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e9f2;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.card-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.card-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  background: #e5e9f2;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b73e8 0%, #805af5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  flex-shrink: 0;
}

.card-name {
  font-size: 14px;
  font-weight: 700;
  color: #1c273c;
  margin: 0;
  line-height: 1.3;
}

.card-role {
  font-size: 12px;
  color: #8392a5;
  margin: 2px 0 0;
}

.menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #8392a5;
  font-size: 16px;
  padding: 2px 4px;
  line-height: 1;
}

.menu-btn:hover {
  color: #1c273c;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #596882;
}

.info-row i {
  width: 14px;
  text-align: center;
  color: #8392a5;
  font-size: 12px;
}

.card-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tag {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1.5px solid;
}

.tag-collab {
  color: #10b981;
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.06);
}

.tag-rated {
  color: #f59e0b;
  border-color: #f59e0b;
  background: rgba(245, 158, 11, 0.06);
}

.card-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f0f3f7;
  padding-top: 12px;
  margin-top: 2px;
}

.footer-actions {
  display: flex;
  gap: 14px;
}

.footer-actions a {
  color: #8392a5;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.15s;
}

.footer-actions a:hover {
  color: #5b73e8;
}

.footer-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b73e8 0%, #805af5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}
</style>
